import { constants } from "../../constants";
import { Currency } from "../../types/enums/Currency";
import { SecurityIdentifier as SecurityIdentifierEntry } from "../../types/security/SecurityClassDetails";
import { SecurityIdentifierType } from "../../types/security/SecurityIdentifierType";

interface Props {
    ticker: string
    identifiers: SecurityIdentifierEntry[]
    currency?: Currency
}
export function SecurityIdentifier({ ticker, identifiers, currency }: Props) {
    const tickerEntry = identifiers.find(x =>
        x.identifier?.localeCompare(ticker, undefined, { sensitivity: 'accent' }) === 0)

        const render = (content: string) => <span>{content}</span>;

    if (!tickerEntry) return render(constants.emptyPlaceholder);

    const { isin, cusip } = getIsinCusipTypeByTickerType(tickerEntry.type) ?? {};

    let primaryType: SecurityIdentifierType | undefined;
    let secondaryType: SecurityIdentifierType | undefined;

    if (currency === Currency.USD) {
        primaryType = cusip;
        secondaryType = isin;
    } else {
        primaryType = isin;
        secondaryType = cusip;
    }

    const content = identifiers.find(x => x.type === primaryType)?.identifier ??
        identifiers.find(x => x.type === secondaryType)?.identifier ??
        constants.emptyPlaceholder;

    return render(content);

}

function getIsinCusipTypeByTickerType(tickerType: SecurityIdentifierType): { isin: SecurityIdentifierType; cusip: SecurityIdentifierType } | null {
    switch (tickerType) {
        case SecurityIdentifierType.Ticker144a:
            return { isin: SecurityIdentifierType.ISIN144a, cusip: SecurityIdentifierType.CUSIP144a };
        case SecurityIdentifierType.TickerRegS:
            return { isin: SecurityIdentifierType.ISINRegS, cusip: SecurityIdentifierType.CUSIPRegS };
        case SecurityIdentifierType.TickerAccd:
            return { isin: SecurityIdentifierType.ISINAccd, cusip: SecurityIdentifierType.CUSIPAccd };
        default:
            return null;
    }
}